import type { LiveTrackHistorySample } from "@/features/deployment-dashboard/live-view/model/live-track-history";
import type { LiveTrailSegment } from "@/features/deployment-dashboard/types";
import {
  worldToFloorplanPixel,
  type WorldToPixelTransformAsset,
} from "@/features/deployment-dashboard/widgets/panels/facility-schematic/services/world-to-pixel-transform";

const FADE_TICKS = 3;

export function deriveLiveTrackLayers(
  transform: Pick<WorldToPixelTransformAsset, "matrix"> | undefined,
  samples: LiveTrackHistorySample[],
  currentTick: number
): LiveTrailSegment[] {
  if (!transform || samples.length === 0) return [];

  const tracks = samples.map((sample) => {
    const remainingTicks = sample.expiresAtTick - currentTick;
    const opacity = Math.min(1, remainingTicks / FADE_TICKS);

    return {
      id: sample.id,
      trackId: sample.trackId,
      tick: sample.tick,
      opacity,
      ...worldToFloorplanPixel(transform, sample.worldX, sample.worldY),
    };
  });

  const trails: LiveTrailSegment[] = [];
  const previousByTrackId = new Map<
    string,
    { id: string; x: number; y: number; opacity: number }
  >();
  for (const track of tracks) {
    const previous = previousByTrackId.get(track.trackId);
    if (previous) {
      trails.push({
        id: `${previous.id}:${track.tick}`,
        start: [previous.x, previous.y],
        end: [track.x, track.y],
        opacity: Math.min(previous.opacity, track.opacity),
      });
    }
    previousByTrackId.set(track.trackId, track);
  }

  return trails;
}
